import type { RovoConfiguration } from '@confluence/rovo-config-provider-common/entry-points/rovoConfigTypes.ts';

import type { OnboardingRovoConfig } from '../hooks/useOnboardingRovoConfig.tsx';

/**
 * Overlays the onboarding greeting and actions on the consumer's base Rovo
 * config when the user is in the experiment cohort; otherwise returns the base
 * config unchanged.
 */
export function applyOnboardingRovoConfig(
	baseConfig: RovoConfiguration,
	onboardingConfig: OnboardingRovoConfig | null,
): RovoConfiguration {
	if (onboardingConfig === null) {
		return baseConfig;
	}

	return {
		...baseConfig,
		getActions: () => Promise.resolve(onboardingConfig.actions),
		customGreeting: onboardingConfig.greeting,
		shouldShowGreeting: true,
		prioritizeCustomActionResults: true,
		numStartersToShow: 2,
	};
}
